import AboutConfig from './AboutConfig';
import DashboardConfig from './DashboardConfig';
import PathwaysConfig from './PathwaysConfig';

const domainsConfigs = [AboutConfig, DashboardConfig, PathwaysConfig];

export default domainsConfigs;
